<template>
  <table class="table table-bordered">
      <thead class="thead-dark">
        <tr>
          <th class="text-center">ID</th>
          <th class="text-center">Timestamp</th>
          <th class="text-center">Odometer KMs</th>
          <th class="text-center">Distance Log Interval</th>
          <th class="text-center">Manually Added</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="odometerLog in odometerLogs" :key="odometerLog.id">
          <td>{{ odometerLog.id }}</td>
          <td>{{ odometerLog.timestamp }}</td>
          <td>{{ odometerLog.odometerKms }}</td>
          <td>{{ odometerLog.distanceLogInterval }}</td>
          <td><input class="form-check-input" type="checkbox" :checked="odometerLog.isManuallyAdded" disabled /></td>          
        </tr>
      </tbody>
    </table>
</template>

<script>
import { apiClient } from '../../helpers/api-client';
import { HTTP_METHODS, HTTP_STATUS_CODES } from '../../helpers/config';

export default {
  name: 'OdometerLogsView',
  setup() {},
  data(){
    return {
      odometerLogs: []
    }
  },
  async created(){
    const vehicleId = this.$route.params.id;
    await this.loadOdometerLogs(vehicleId);
  },
  methods: {
    loadOdometerLogs: async function(vehicleId) {
      const result = await apiClient(`vehicles/${vehicleId}/odometerlogs`, HTTP_METHODS.GET);
      if (result.status === HTTP_STATUS_CODES.SUCCESS) {
        this.odometerLogs = result.data.sort(function(a,b){
          return new Date(b.timestamp) - new Date(a.timestamp);
        });
      }
    }
  }
}
</script>